/**
 * Может ли пользователь подать заявку в команду.
 *
 * KAN-368: правило само по себе простое — авторизован и не состоит в постоянной
 * команде. Ломалось оно на третьем состоянии, которого в правиле не было:
 * «ответ ещё не пришёл».
 *
 * В коде стоял дефолт `useQuery({ ... }).data = []`, из-за чего «ещё не знаем»
 * было неотличимо от «команд нет». Пока запрос летел, ответ считался
 * отрицательным, кнопка «Подать заявку» успевала отрисоваться и исчезала после
 * прихода данных — капитан команды видел её мигание на каждой загрузке списка.
 *
 * Отсюда правило, которое стоит применять к любому разрешению: пока ответ
 * неизвестен, действие НЕ разрешено. Мигание кнопки, которой не должно быть,
 * хуже, чем её появление на долю секунды позже.
 */

export type RosterMembershipTeam = { isTemporary?: boolean | null };

export type CanApplyInput = {
  /** Идентификатор текущего пользователя; пусто — не авторизован. */
  userId?: string | null;
  /**
   * Команды пользователя. `undefined` означает «ответ ещё не получен» — именно
   * это состояние и нужно отличать от пустого списка.
   */
  myTeams?: RosterMembershipTeam[] | undefined;
};

export function canApplyToRoster({ userId, myTeams }: CanApplyInput): boolean {
  if (!userId) return false;
  // Состав команд пользователя ещё неизвестен — отвечать «можно» рано.
  if (myTeams === undefined) return false;
  // Временная команда (например, Arena) подаче заявки не мешает.
  return !myTeams.some((t) => !t.isTemporary);
}
